import React from 'react';
import { BundlePrice } from './BundlePrice';
export const BundlePricePortal = ({ price, compare_at_price, product_shipping_callout, translations, locale, currency }) => {
    return React.createElement(BundlePrice, { locale: locale, currency: currency, price: price, compare_at_price: compare_at_price, product_shipping_callout: product_shipping_callout, translations: translations });
};
